import React from 'react';
import { CheckboxList, CheckboxListProps } from '@legacy-vfuk/core-checkbox-list';
import { ContentfulFilters } from './types/SectionFilterableArticles.types';

type DrawerChecboxList = {
  label: string;
  tempFilterList: ContentfulFilters;
  filters: ContentfulFilters;
  updateFilterList: (slugName: string) => void;
};

const DrawerCheckboxList = ({
  tempFilterList,
  label,
  filters,
  updateFilterList,
}: DrawerChecboxList) => {
  const chekcboxStates = filters.map(filter =>
    tempFilterList.some(f => f.slugName === filter.slugName)
  );

  const checkboxItems: CheckboxListProps['checkboxes']['items'] = filters.map(
    (filter, idx) => ({
      label: filter.displayName,
      value: filter.slugName,
      checked: chekcboxStates[idx],
    })
  );

  const checkboxes: CheckboxListProps['checkboxes'] = {
    id: label,
    groupName: label,
    items: checkboxItems,
    onChange: e => {
      updateFilterList(e.target.value);
    },
  };

  return (
    <CheckboxList
      checkboxes={checkboxes}
      fieldWrapper={{
        label: label,
        showLabel: false,
      }}
    />
  );
};

export default DrawerCheckboxList;
